/**
 * /eric/content — Content queue (T-050, PR-30, DES-05).
 *
 * Route config only. Component lives in eric.content.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/content')({});
